import { getYouTubeVideoParams, YouTubeVideo } from "../../YouTubeVideo";
import { Video } from "../../YouTubeVideo/StorageVideo";
import { Speaker } from "./Speaker";
import { VocabList } from "./VocabList";

const imgExtensions = [".png", ".jpg", ".gif"];
const soundExtensions = [".m4a"];
const videoExtensions = [".mp4"];

export function checkImgExtension(str: string) {
    return checkExtension(str, imgExtensions);
}

function checkExtension(str: string, extensions: string[]) {
    if (!str) {
        return false;
    }
    return extensions.some(e => str.toLowerCase().includes(e));
}

export const ImageRender = ({ src, alt }: { src?: string; alt?: string }) => {
    if (!src || !alt) {
        return null;
    }

    if (src.startsWith("youtube")) {
        const { videoId, isShorts } = getYouTubeVideoParams(alt);
        return (
            <YouTubeVideo
                screenWidth={window.innerWidth}
                pageNameForLog={"markDown embedded"}
                videoId={videoId}
                isShorts={isShorts}
                buttonLabel={
                    src.includes("-")
                        ? src.split("-")[1].split("_").join(" ")
                        : ""
                }
            />
        );
    }
    if (checkExtension(src, soundExtensions)) {
        return <Speaker src={src} alt={alt} />;
    }
    if (checkExtension(src, videoExtensions)) {
        return (
            <div style={{ textShadow: "none" }}>
                <Video
                    path={src}
                    screenWidth={300}
                    pageNameForLog="MarkdownVideo"
                />
            </div>
        );
    }
    if (src === "vocab") {
        return <VocabList genreName={alt} />;
    }
    return <img src={src} alt={alt} title={alt} className="renderedImg" />;
};
